// extracted by mini-css-extract-plugin
export default {"download":"Download_download__B08lj","screenshot2":"Download_screenshot2__pXjRE","download_button":"Download_download_button__AOHdj"};